"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _style = _interopRequireDefault(require("./style.css"));
var _fileEmpty = _interopRequireDefault(require("cccisd-icons/file-empty"));
var _paste = _interopRequireDefault(require("cccisd-icons/paste2"));
var _upload = _interopRequireDefault(require("cccisd-icons/upload"));
var _blank = _interopRequireDefault(require("./blank.png"));
var _none = _interopRequireDefault(require("./none.png"));
var _low = _interopRequireDefault(require("./low.png"));
var _moderate = _interopRequireDefault(require("./moderate.png"));
var _veryHigh = _interopRequireDefault(require("./veryHigh.png"));
var _cccisdFormik = require("cccisd-formik");
var _ImagePicker = _interopRequireDefault(require("./ImagePicker"));
var _reactDropzone = _interopRequireDefault(require("react-dropzone"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _cccisdClickButton = _interopRequireDefault(require("cccisd-click-button"));
var _ExistingSurveysTable = _interopRequireDefault(require("./ExistingSurveysTable.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var startWithOptions = [{
  handle: 'none',
  label: 'Blank',
  thumbnail: _blank["default"],
  tooltip: 'Build your survey from scratch!'
}, {
  handle: 'none.flow.json',
  label: 'Example 1',
  thumbnail: _none["default"],
  tooltip: /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      textAlign: 'left'
    }
  }, "Example Survey 1 contains pre-filled question examples recommended for respondents with a 9th grade reading level or higher. No accommodation support features are turned on.")
}, {
  handle: 'low.flow.json',
  label: 'Example 2',
  thumbnail: _low["default"],
  tooltip: /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      textAlign: 'left'
    }
  }, "Example Survey 2 contains pre-filled question examples and survey settings recommended for respondents with a 6th \u2013 8th grade reading level. No accommodation support features are turned on.")
}, {
  handle: 'moderate.flow.json',
  label: 'Example 3',
  thumbnail: _moderate["default"],
  tooltip: /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      textAlign: 'left'
    }
  }, "Example Survey 3 contains pre-filled question examples recommended for respondents with a 3rd \u2013 5th grade reading level. The following accommodation support features are turned on:", /*#__PURE__*/_react["default"].createElement("ul", null, /*#__PURE__*/_react["default"].createElement("li", null, "Auto-play instructions/questions"), /*#__PURE__*/_react["default"].createElement("li", null, "Auto-play response choices")))
}, {
  handle: 'very_high.flow.json',
  label: 'Example 4',
  thumbnail: _veryHigh["default"],
  tooltip: /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      textAlign: 'left'
    }
  }, "Example Survey 4 contains pre-filled question examples recommended for respondents with a Pre-K \u2013 2nd grade reading level. The following accommodation support features are turned on:", /*#__PURE__*/_react["default"].createElement("ul", null, /*#__PURE__*/_react["default"].createElement("li", null, "Auto-play instructions/questions"), /*#__PURE__*/_react["default"].createElement("li", null, "Auto-play response choices"), /*#__PURE__*/_react["default"].createElement("li", null, "Synchronized text highlighting"), /*#__PURE__*/_react["default"].createElement("li", null, "Response choice masking")))
}];
var validate = function validate(values) {
  var errors = {};
  if (values.createFlow === 'existing' && !values.copyFlowId) {
    errors.copyFlowId = 'You have to pick one survey';
  }
  return errors;
};
var FlowModalContents = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function FlowModalContents(props) {
    var _this;
    _classCallCheck(this, FlowModalContents);
    _this = _callSuper(this, FlowModalContents, [props]);
    _defineProperty(_this, "openFileDialog", function () {
      _this.dropzone.current.open();
    });
    _defineProperty(_this, "renderStartWithBlock", function () {
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].blockComment
      }, "Select your desired template from the options below. Hover over each option to learn more about the pre-set survey settings, questions types, and accommodation support features."), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "startWith",
        component: _ImagePicker["default"],
        options: startWithOptions,
        width: "140px",
        height: "140px",
        isScrollView: false
      }));
    });
    _defineProperty(_this, "renderExistingBlock", function () {
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "copyFlowId",
        render: function render(_ref) {
          var field = _ref.field,
            form = _ref.form;
          return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdFieldWrapper, {
            field: field,
            form: form
          }, /*#__PURE__*/_react["default"].createElement(_ExistingSurveysTable["default"], {
            selected: field.value,
            onSelect: function onSelect(value) {
              return form.setFieldValue('copyFlowId', value);
            }
          }));
        }
      });
    });
    _defineProperty(_this, "renderFromFileBlock", function () {
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "file",
        render: function render(_ref2) {
          var field = _ref2.field,
            form = _ref2.form;
          return /*#__PURE__*/_react["default"].createElement(_reactDropzone["default"], {
            ref: _this.dropzone,
            onDrop: function onDrop(accepted, rejected) {
              if (rejected.length > 0 || accepted.length !== 1) {
                (0, _cccisdNotification["default"])({
                  message: 'You have to choose one json file',
                  type: 'danger'
                });
                return;
              }
              form.setFieldValue('file', accepted[0]);
            },
            noClick: true,
            noKeyboard: true,
            accept: "application/json"
          }, function (_ref3) {
            var isDragActive = _ref3.isDragActive,
              getRootProps = _ref3.getRootProps,
              getInputProps = _ref3.getInputProps;
            return /*#__PURE__*/_react["default"].createElement("div", _extends({
              style: {
                position: 'relative'
              }
            }, getRootProps()), /*#__PURE__*/_react["default"].createElement("div", {
              className: (0, _classnames2["default"])(_style["default"].dropArea, _defineProperty({}, _style["default"].active, isDragActive))
            }, "Drop files here"), /*#__PURE__*/_react["default"].createElement("input", getInputProps()), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdFieldWrapper, {
              field: field,
              form: form
            }, /*#__PURE__*/_react["default"].createElement("div", {
              className: _style["default"].uploadWrapper
            }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("button", {
              onClick: _this.openFileDialog,
              className: "btn btn-secondary",
              type: "button"
            }, /*#__PURE__*/_react["default"].createElement(_upload["default"], null), " Upload")), field.value && /*#__PURE__*/_react["default"].createElement("div", {
              className: _style["default"].fileDescriptor
            }, field.value.name))));
          });
        }
      });
    });
    _this.dropzone = /*#__PURE__*/_react["default"].createRef();
    return _this;
  }
  _inherits(FlowModalContents, _React$Component);
  return _createClass(FlowModalContents, [{
    key: "render",
    value: function render() {
      var assignmentProjectLanguageStr = this.props.assignmentProjectLanguageStr;
      var createFlowOptions = [{
        value: 'startWith',
        label: 'Start with...',
        icon: /*#__PURE__*/_react["default"].createElement(_fileEmpty["default"], null),
        renderBlock: this.renderStartWithBlock
      }, {
        value: 'existing',
        label: 'Copy from system',
        icon: /*#__PURE__*/_react["default"].createElement(_paste["default"], null),
        renderBlock: this.renderExistingBlock
      }, {
        value: 'fromFile',
        label: 'Import from file',
        icon: /*#__PURE__*/_react["default"].createElement(_upload["default"], null),
        renderBlock: this.renderFromFileBlock
      }];
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
        initialValues: {
          createFlow: 'startWith',
          startWith: startWithOptions[0].handle
        },
        onSubmit: this.props.onSubmit,
        validate: validate,
        render: function render(_ref4) {
          var handleSubmit = _ref4.handleSubmit,
            isSubmitting = _ref4.isSubmitting;
          return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Form, null, assignmentProjectLanguageStr && /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].project
          }, assignmentProjectLanguageStr), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
            name: "createFlow",
            render: function render(_ref5) {
              var field = _ref5.field,
                form = _ref5.form;
              return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdFieldWrapper, {
                field: field,
                form: form
              }, createFlowOptions.map(function (option) {
                return /*#__PURE__*/_react["default"].createElement("div", {
                  key: option.value
                }, /*#__PURE__*/_react["default"].createElement("div", {
                  className: "form-check mb-3"
                }, /*#__PURE__*/_react["default"].createElement("label", {
                  className: "form-check-label"
                }, /*#__PURE__*/_react["default"].createElement("input", _extends({
                  className: "form-check-input",
                  type: "radio"
                }, field, {
                  checked: field.value === option.value,
                  value: option.value
                })), ' ', option.icon, " ", option.label)), field.value === option.value && option.renderBlock && /*#__PURE__*/_react["default"].createElement("div", {
                  className: _style["default"].block
                }, option.renderBlock()));
              }));
            }
          }), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
            className: "btn btn-primary",
            title: "Submit",
            isLoading: isSubmitting,
            onClick: handleSubmit
          })));
        }
      });
    }
  }]);
}(_react["default"].Component);
_defineProperty(FlowModalContents, "propTypes", {
  assignmentProjectLanguageStr: _propTypes["default"].string,
  closeModal: _propTypes["default"].func,
  onSubmit: _propTypes["default"].func.isRequired
});